<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Configurer: Intro Mobile App</h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <div v-for="(item, index) in formData.items" :key="index" class="item-group mb-4">
                                <!-- Name -->
                                <div class="col-12 col-md-12">
                                    <label for="name" class="form-label mt-2">Nom<span class="text-purple">*</span></label>
                                    <input
                                        type="text"
                                        class="form-control fs-6 py-2"
                                        v-model="item.name"
                                        :placeholder="`Entrez le nom ${index + 1}`"
                                    />
                                    <div v-if="errors[`items[${index}].name`]" class="invalid-feedback">
                                        {{ errors[`items[${index}].name`] }}
                                    </div>
                                </div>
                                <!-- Description -->
                                <div class="col-12 col-md-12">
                                    <label class="form-label" for="description">Description</label>
                                    <textarea
                                        name="description"
                                        cols="30"
                                        rows="4"
                                        class="form-control"
                                        v-model="item.description"
                                        :placeholder="`Entrez la description ${index + 1}`"
                                    ></textarea>
                                </div>

                                <!-- Image Upload -->
                                <div class="col-12 mt-2">
                                    <label class="form-label pb-2" for="image">Image</label>
                                    <div
                                        class="form-control overflow-hidden text-center new-image"
                                        style="cursor: pointer; padding-top: 33px"
                                    >
                                        <input
                                            type="file"
                                            :id="`image-input-${index}`"
                                            hidden
                                            @change="handleImageUpload($event, index)"
                                            accept="image/*"
                                        />
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="29"
                                            height="24"
                                            viewBox="0 0 29 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M7.33321 19.0016C5.66958 19.0016 4.07409 18.3694 2.89772 17.2442C1.72136 16.119 1.06049 14.5929 1.06049 13.0016C1.06049 11.4103 1.72136 9.88414 2.89772 8.75892C4.07409 7.6337 5.66958 7.00156 7.33321 7.00156C7.72613 5.25113 8.87556 3.71287 10.5287 2.72518C11.3472 2.23613 12.2647 1.89696 13.2289 1.72705C14.1931 1.55713 15.185 1.5598 16.148 1.7349C17.1111 1.90999 18.0263 2.25409 18.8416 2.74754C19.6569 3.24098 20.3562 3.87412 20.8996 4.6108C21.443 5.34748 21.8198 6.17327 22.0086 7.04102C22.1974 7.90878 22.1944 8.8015 21.9999 9.66823H23.3332C24.5709 9.66823 25.7579 10.1599 26.633 11.0351C27.5082 11.9102 27.9999 13.0972 27.9999 14.3349C27.9999 15.5726 27.5082 16.7596 26.633 17.6347C25.7579 18.5099 24.5709 19.0016 23.3332 19.0016H21.9999"
                                                stroke="#021832"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M9.99988 15L13.9999 11L17.9999 15"
                                                stroke="#021832"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                            <path
                                                d="M13.9999 11V23"
                                                stroke="#021832"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>

                                        <label
                                            :for="`image-input-${index}`"
                                            class="form-control text-center"
                                            style="cursor: pointer"
                                            >Télécharger image</label
                                        >

                                        <span class="max-text">Taille recommender 275/275px</span>
                                        <img
                                            v-if="item.image_url"
                                            :src="item.image_url"
                                            class="border-0 rounded-12"
                                            style="width: 360px"
                                        />
                                        <div v-if="errors[`items[${index}].image`]" class="invalid-feedback">
                                            {{ errors[`items[${index}].image`] }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-4">
                                    <button
                                        type="button"
                                        @click="removeItem(index)"
                                        class="btn btn-minuss btn-outline-secondary rounded-circle m-1"
                                        v-if="formData.items.length > 1"
                                    >
                                        -
                                    </button>
                                    <button
                                        type="button"
                                        @click="addItem"
                                        class="btn_pluss btn-primary text-white rounded-circle m-1"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-4 pt-2 gap-40 flex-wrap mx-6">
                                <button type="submit" class="btn btn-dark rounded-12 fw-semibold width-btn height_btn_page">
                                    {{ 'Valider' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formData: {
                items: [
                    {
                        name: '',
                        description: '',
                        image: null,
                    },
                ],
            },
            errors: {},
            removedItemsIds: [],
        }
    },

    computed: {
        countItems() {
            return this.formData.items.filter((item) => item.name.trim() !== '').length
        },
    },

    methods: {
        addItem() {
            this.formData.items.push({
                id: -1,
                name: '',
                description: '',
                image: null,
            })
        },

        removeItem(index) {
            const itemId = this.formData.items[index].id
            if (itemId) {
                this.removedItemsIds.push(itemId)
            }
            this.formData.items.splice(index, 1)
        },

        handleImageUpload(event, index) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(this.formData.items[index], 'image', e.target.result)
                    this.$set(this.formData.items[index], 'image_url', URL.createObjectURL(file))
                }
                reader.readAsDataURL(file)
            }
        },

        handleSubmit() {
            this.errors = {}
            this.createOrUpdate()
        },

        async getData() {
            axios
                .get('/back-office/mobile-app-intro')
                .then((response) => {
                    this.formData.items = response.data

                    if (this.formData.items.length == 0) {
                        this.addItem()
                    }
                })
                .catch((error) => {
                    console.error('Error creating package:', error)
                })
        },

        async store() {
            axios
                .post('/back-office/mobile-app-intro', this.formData.items)
                .then((response) => {
                    this.$toast.success(this.$t('common.settings_updated_success'))
                    /*
                    setTimeout(() => {
                        window.location.href = '/back-office/tags'
                    }, 2000)
                    */
                })
                .catch((error) => {
                    console.error('Error creating package:', error)
                    this.showErrors(error.response)
                })
        },

        async createOrUpdate() {
            axios
                .post('/back-office/mobile-app-intro/', { items: this.formData.items, removedItemsIds: this.removedItemsIds })
                .then((response) => {
                    this.$toast.success(this.$t('common.settings_updated_success'))
                })
                .catch((error) => {
                    console.error('Error updating tag:', error)
                    this.showErrors(error.response)
                })
        },

        showErrors(response) {
            this.errors = {}
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors
                for (const key in errors) {
                    let errorMessage = errors[key][0]
                    this.$set(this.errors, key, errorMessage)
                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },
    },

    mounted() {
        this.getData()
    },
}
</script>

<style scoped>
.btn-minuss,
.btn_pluss {
    float: right;
}
</style>
